<template>
  <section class="relative h-[calc(100vh-64px)] overflow-hidden">
    <!-- Background image -->
    <template v-if="props.solidBackground">
      <div
        class="absolute inset-0 h-full -z-10 pointer-events-none"
        :style="{ backgroundColor: props.solidColor }"
      ></div>
    </template>
    <template v-else>
      <div class="absolute inset-0 h-full -z-10 pointer-events-none">
        <img
          :src="backgroundSrc"
          alt="Contato - Kali Sistemas"
          class="w-full h-full object-cover object-top select-none absolute inset-0"
        />
      </div>
    </template>

    <!-- Content (slot para sobrepor elementos, como o formulário) -->
    <div class="relative z-10 h-full flex items-center">
      <main class="mt-0 mx-auto w-full max-w-[1440px] px-6">
        <div
          class="grid grid-cols-1 xl:grid-cols-2 gap-12 items-center h-full w-full"
        >
          <div class="xl:col-start-2 justify-self-end w-full">
            <slot />
          </div>
        </div>
      </main>
    </div>
  </section>
</template>

<script setup>
defineOptions({ name: "ContactHeroSection" });
import { computed } from "vue";
import contactBg from "@/assets/contact-bg.webp";

const props = defineProps({
  background: { type: String, default: "" },
  solidBackground: { type: Boolean, default: false },
  solidColor: { type: String, default: "#00ff00" },
});

const backgroundSrc = computed(() => {
  // Se nenhuma imagem for informada via prop, usa a padrão
  if (!props.background) return contactBg;
  // Suporta URLs absolutas
  if (/^https?:\/\//.test(props.background)) return props.background;
  // Fallback seguro
  return contactBg;
});
</script>
